import workspaceQuery from '../../../graphql/queries/sales/WebConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/WebConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/WebConfigurationQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/WebConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/WebConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';
import defaultQuery from '../../queries/sales/WebConfigurationDefault.graphql';

const WebConfiguration: EntityType = {
  type: 'WebConfiguration',
  title: 'Web Configurations',
  formTitle: 'Web Configuration',
  formUrl: '/Sales/Channel/WebConfig/Details/',
  workspaceUrl: '/Sales/Channel/WebConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_WEB_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default WebConfiguration;
